import { Download, FileText } from "lucide-react";
import { SELLER_GUIDE_IMAGE } from "../data";
import { Reveal } from "./Reveal";

const GUIDE_FILENAME = "Sellers-Guide-Maximizing-Property-Value.png";

// compact = inline card (e.g. inside the seller quiz result); default = full banner
export const SellerGuide = ({ compact = false }) => {
  if (compact) {
    return (
      <div data-testid="seller-guide-compact" className="bg-surface border border-black/5 p-5 mt-8 flex items-center gap-5 text-left">
        <img src={SELLER_GUIDE_IMAGE} alt="Seller's Guide cover" className="w-14 h-18 object-cover border border-black/10 hidden sm:block" />
        <div className="flex-1">
          <p className="font-heading text-lg leading-snug">A Seller's Guide to Maximizing Property Value</p>
          <p className="text-sm text-[#52525b] font-light mt-1">Free download — expert strategies to sell for top dollar.</p>
        </div>
        <a
          href={SELLER_GUIDE_IMAGE}
          download={GUIDE_FILENAME}
          target="_blank"
          rel="noreferrer"
          data-testid="seller-guide-download-compact"
          className="inline-flex items-center gap-2 bg-[#0a0a0a] text-white text-sm px-5 py-3 hover:bg-[#27272a] transition-colors whitespace-nowrap"
        >
          <Download size={15} /> Get Guide
        </a>
      </div>
    );
  }

  return (
    <div id="seller-guide" data-testid="seller-guide" className="bg-surface border-b border-black/5 py-16 md:py-20">
      <div className="max-w-7xl mx-auto px-6 md:px-12 grid lg:grid-cols-12 gap-10 lg:gap-16 items-center">
        <Reveal className="lg:col-span-7">
          <div className="flex items-center gap-3 mb-4">
            <FileText className="text-gold" size={22} />
            <p className="eyebrow text-gold">Free Seller Download</p>
          </div>
          <h2 className="font-heading text-3xl sm:text-5xl font-light leading-tight">
            A Seller's Guide to Maximizing Property Value
          </h2>
          <p className="text-[#52525b] font-light text-lg mt-5 max-w-xl leading-relaxed">
            Expert strategies, local Inland Empire insight, and a step-by-step plan to prepare, price,
            and market your home for top dollar — yours to download free.
          </p>
          <a
            href={SELLER_GUIDE_IMAGE}
            download={GUIDE_FILENAME}
            target="_blank"
            rel="noreferrer"
            data-testid="seller-guide-download"
            className="inline-flex items-center gap-2 bg-[#0a0a0a] text-white text-sm px-8 py-4 mt-8 hover:bg-[#27272a] transition-colors tracking-wide"
          >
            <Download size={16} /> Download the Free Guide
          </a>
        </Reveal>

        <Reveal delay={0.1} className="lg:col-span-5">
          <a href={SELLER_GUIDE_IMAGE} download={GUIDE_FILENAME} target="_blank" rel="noreferrer" className="block group">
            <img
              src={SELLER_GUIDE_IMAGE}
              alt="A Seller's Guide to Maximizing Property Value"
              className="w-full border border-black/10 shadow-xl group-hover:-translate-y-1 transition-transform duration-300"
            />
          </a>
        </Reveal>
      </div>
    </div>
  );
};
